import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default (props) => (
  <SvgIcon {...props}>
    <path d="m5 3h5v2h-5v14h5v2h-5c-1.1046 0-2-0.89543-2-2v-14c0-1.11 0.9-2 2-2" />
    <path d="m13.92 15.58-1.42 1.42-5-5 5-5 1.42 1.41-2.59 2.59h9.67v2h-9.67z" />
  </SvgIcon>
);
